<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input size="small" v-model="query.keyword" clearable maxlength="12" placeholder="关键词"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-select size="small" v-model="query.keyTypeId" filterable clearable placeholder="风险类型"
					class="handle-select mr10" style="width: 180px;">
					<el-option v-for="item in riskTypeList" :key="item.value" :label="item.value"
						:value="item.label"></el-option>
				</el-select>
				<el-select size="small" v-model="query.gradeTypeId" filterable clearable placeholder="风险等级"
					class="handle-select mr10" style="width: 180px;">
					<el-option v-for="item in riskGradeList" :key="item.value" :label="item.value"
						:value="item.label"></el-option>
				</el-select>
				<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getData">搜索</el-button>
				<el-button size="small" type="primary" :class="[theme]" @click="handleEdit">添加</el-button>

			</div>
			<el-table v-loading="loading" :data="tableData" border class="table m_t_20"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }"
				:header-cell-style="{ 'text-align': 'center' }" :cell-style="{ padding: '6px' }" stripe>
				<el-table-column prop="keyType" label="类型" align="center"></el-table-column>
				<el-table-column prop="keyword" label="关键词" align="center"></el-table-column>
				<el-table-column prop="splitKeyword" label="分词" align="center"></el-table-column>
				<el-table-column prop="grade" label="等级" align="center"></el-table-column>
				<el-table-column prop="createTime" label="时间" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template #default="scope">
						<el-button size="small" type="danger" @click.stop="handleDelete(scope.row)">删除</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click.stop="handleEdit(scope.row)">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="query.current"
					:page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="query.size" :total="pageTotal"
					@size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
			</div>
		</div>
		<el-dialog :title="editFormTitle" v-model="editVisible" width="600px" @close="closeDialog"
			:close-on-click-modal="false">
			<el-form :model="editform" ref="addform" label-width="100px">
				<el-form-item label="风险类型" prop="keyTypeId">
					<el-select size="small" v-model="editform.keyTypeId" filterable clearable placeholder="风险类型"
						class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in riskTypeList" :key="item.value" :label="item.value"
							:value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="风险等级" prop="gradeTypeId">
					<el-select size="small" v-model="editform.gradeTypeId" filterable clearable placeholder="风险等级"
						class="handle-select mr10" style="width: 100%;">
						<el-option v-for="item in riskGradeList" :key="item.value" :label="item.value"
							:value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关键词" prop="keyword">
					<el-input size="small" v-model="editform.keyword"></el-input>
				</el-form-item>
				<el-form-item label="分词" prop="splitKeyword">
					<el-input size="small" v-model="editform.splitKeyword"
						style="width: 180px;margin-right: 10px;;display: none;" disabled></el-input>
					<el-tag class="m_r_10" v-for="tag in splitKeywordList" :key="tag" closable
						:disable-transitions="false" @close="handleClose(tag)">{{ tag }}</el-tag>
					<el-input size="small" class="input-new-tag" v-if="inputVisible" v-model="inputValue"
						ref="saveTagInput" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm"></el-input>
					<el-button size="small" v-else class="button-new-tag" @click="showInput">+标签名</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getPreviewTerm">预览分词</el-button>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getKeywordSaves">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="导入" v-model="importVisible" width="600px" @close="closeDialog" :close-on-click-modal="false">
			<el-form label-width="100px">
				<el-form-item label="上传文件">
					<el-upload ref="upload" action="/api/risk/keyword/import" :headers="token" :limit="1"
						:on-success="uploadSuccess" :auto-upload="false" :data="importForm" name="excelFile">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top:40px;">选择文件</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitUpload">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	import {
		getKeywordList,
		getKeywordDelete,
		getKeywordSave,
		getKeywordImport,
		queryTypeOptions,
		previewTerm
	} from '../api/inspection.js';
	export default {
		name: 'telephoneInspection',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					keyTypeId: '',
					keyword: '',
					gradeTypeId: '',
					current: 1,
					size: 10,
				},
				typeList: [{
						value: 1,
						label: '关键字类型'
					},
					{
						value: 2,
						label: '风险级别'
					}
				],
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				pageTotal: 0,
				tableData: [],
				editVisible: false,
				editFormTitle: "",
				editform: {
					keyTypeId: '',
					keyword: '',
					splitKeyword: '',
					gradeTypeId: '',
				},
				importVisible: false,
				inputVisible: false,
				inputValue: '',
				importForm: {},
				riskTypeList: [],
				riskGradeList: [],
			};
		},
		created() {
			this.getData();
			this.getQueryTypeOptions();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.number:hover {
				        color: ${this.theme8} !important;
				    }
					.active:hover {
					    color: #fff !important;
					}
					.more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			getQueryTypeOptions() {
				let data = {
					type_id: ''
				}
				queryTypeOptions(data).then(res => {
					if (res?.code === 200) {
						this.riskTypeList = res.data.riskTypeOptions;
						this.riskGradeList = res.data.riskGradeOptions;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getData() {
				this.loading = true;
				getKeywordList(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleDelete(row) {
				// 二次确认删除
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							id: row.id
						};
						getKeywordDelete(data).then(res => {
							if (res?.code === 200) {
								this.$message.success(res.message);
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			handleEdit(row) {
				if (row.id) {
					this.editFormTitle = '编辑'
					this.editform = row;
					this.splitKeywordList = row.splitKeyword.split(',')
				} else {
					this.editFormTitle = '添加';
					this.splitKeywordList = [];
					this.editform = {
						keyType: "",
						keyword: "",
						splitKeyword: "",
						grade: "",
					}
				}
				this.editVisible = true;
			},
			closeDialog() {
				this.editVisible = false;
				this.importVisible = false;
			},
			getKeywordSaves() {
				this.editform.splitKeyword = this.splitKeywordList.join(',');
				getKeywordSave(this.editform).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.editVisible = false;
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getKeywordImports() {
				this.importVisible = true;
			},
			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.splitKeywordList.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			handleClose(tag) {
				this.splitKeywordList.splice(this.splitKeywordList.indexOf(tag), 1);
				this.editform.splitKeyword = this.splitKeywordList.join('');
			},

			getPreviewTerm() {
				let data = {
					keyword: this.editform.keyword
				}
				previewTerm(data).then(res => {
					if (res?.code === 200) {
						this.editform.splitKeyword = res.data;
						this.splitKeywordList = res.data.split(',');
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//导入
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.$refs.upload.clearFiles();
				}, 2000);
				if (success?.code === 200) {
					this.importVisible = false;
					this.$message.success('上传成功');
					this.getData();
				} else {
					this.$message.error(success.message);
				}
			},
			// 分页导航
			handlePageChange(val) {
				this.query.current = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.query.current = 1; // 重置到第一页
				this.getData();
			},
		}
	};
</script>

<style scoped>
	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}
</style>